module.exports = __webpack_public_path__ + "img/maison-6.12ae1c2a.png";